<div class="infobulle-text">
  <p>
    <b> Minimum : </b>
    {{ detailsGarantiesMinimum }}
  </p>
  <p>
    <b> Moyen : </b>
    {{ detailsGarantiesMoyen }}
  </p>
  <p>
    <b> Fort : </b>
    {{ detailsGarantiesFort }}
  </p>
  <p style="margin-bottom: 0px">
    <b> Maximum : </b>
    {{ detailsGarantiesMaximum }}
  </p>
</div>
